import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ncr-activity-pane" }
const _hoisted_2 = {
  key: 0,
  class: "ncr-pane-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "ncr-audit-list"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { onBeforeUnmount, ref, watch } from 'vue';
import type { Unsubscribe } from 'firebase/firestore';

import { ncrClient, type NcrAuditEntry } from '@/modules/ncr/NcrClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'NcrActivityPane',
  props: {
    recordId: {}
  },
  setup(__props: any) {

const props = __props;
const entries = ref<NcrAuditEntry[]>([]);
let unsubscribe: Unsubscribe | null = null;

function subscribe(recordId: string): void {
  unsubscribe?.();
  unsubscribe = null;
  entries.value = [];
  if (!recordId) return;
  unsubscribe = ncrClient.subscribeToAudit(recordId, nextEntries => {
    entries.value = nextEntries;
  });
}

function displayValue(value: unknown): string {
  if (value === '' || value === null || value === undefined) return 'blank';
  if (Array.isArray(value)) return value.length ? `${value.length} item(s)` : 'blank';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function formatDate(value: any): string {
  if (typeof value?.toMillis === 'function') return new Date(value.toMillis()).toLocaleString();
  if (typeof value?.seconds === 'number') return new Date(value.seconds * 1000).toLocaleString();
  const numeric = Number(value || 0);
  return numeric ? new Date(numeric > 1_000_000_000_000 ? numeric : numeric * 1000).toLocaleString() : '';
}

watch(() => props.recordId, subscribe, { immediate: true });
onBeforeUnmount(() => unsubscribe?.());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (entries.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "No activity recorded yet."))
      : (_openBlock(), _createElementBlock("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry) => {
            return (_openBlock(), _createElementBlock("li", {
              key: entry.id
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ncr-audit-marker" }, null, -1 /* CACHED */)),
              _createElementVNode("div", null, [
                _createElementVNode("header", null, [
                  _createElementVNode("strong", null, _toDisplayString(entry.user || 'System'), 1 /* TEXT */),
                  _createElementVNode("time", null, _toDisplayString(formatDate(entry.timestamp)), 1 /* TEXT */)
                ]),
                (entry.type === 'create')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(displayValue(entry.newValue)) + " was created.", 1 /* TEXT */))
                  : (entry.field === 'files')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Modified an attachment."))
                    : (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _cache[0] || (_cache[0] = _createTextVNode(" Changed ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(entry.field || 'record'), 1 /* TEXT */),
                        _cache[1] || (_cache[1] = _createTextVNode(" from ", -1 /* CACHED */)),
                        _createElementVNode("span", null, _toDisplayString(displayValue(entry.oldValue)), 1 /* TEXT */),
                        _cache[2] || (_cache[2] = _createTextVNode(" to ", -1 /* CACHED */)),
                        _createElementVNode("span", null, _toDisplayString(displayValue(entry.newValue)), 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createTextVNode(". ", -1 /* CACHED */))
                      ]))
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ]))
}
}

})